<template>
  <v-container fluid>
    <!-- TITLE -->
    <v-row>
      <v-col>
        <div class="display-1 pl-2">Test page</div>
      </v-col>
    </v-row>
    <!-- DIVIDER -->
    <v-row>
      <v-col>
        <v-divider />
      </v-col>
    </v-row>
    <!-- CONTENTS -->
    <v-row>
      <v-col> Test contents </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    //
  },
  data() {
    return {
      //
    };
  },
  computed: {
    //
  },
  mounted() {
    //
  },
  methods: {
    //
  },
};
</script>

<style></style>
